import { render } from "./farmingRecord.vue?vue&type=template&id=43512c36&scoped=true&ts=true"
import script from "./farmingRecord.vue?vue&type=script&lang=ts"
export * from "./farmingRecord.vue?vue&type=script&lang=ts"

import "./farmingRecord.vue?vue&type=style&index=0&id=43512c36&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43512c36"]])

export default __exports__